import FixaHelperText from "@coworker/apprestructured/src/shared/wrappers/FixaHelperText/FixaHelperText";
import { useTranslation } from "@coworker/locales";
import { ValidationErrorType } from "./hooks/useValidation";
import type { FileUploadConstraints } from "./types";
import { bytesToMb } from "./utils";

type ValidationMessageProps = {
  validationId: string;
  type: ValidationErrorType;
} & Pick<FileUploadConstraints, "acceptedFileExtensions" | "maxFileSizeBytes">;

export const ValidationMessage = ({
  validationId,
  type,
  acceptedFileExtensions,
  maxFileSizeBytes,
}: ValidationMessageProps) => {
  const { t } = useTranslation();

  let message = "";
  if (type === ValidationErrorType.UnsupportedFileType) {
    message = t("launchMediaUploadUnsupportedFileTypeString", {
      acceptedFileExtensions: acceptedFileExtensions.join(", "),
    });
  } else if (type === ValidationErrorType.FileTooLarge) {
    message = t("launchMediaUploadFileTooLargeString", {
      maxFileSizeMb: bytesToMb(maxFileSizeBytes),
    });
  }

  return (
    <FixaHelperText
      data-testid="upload-media-dropzone-validation"
      shouldValidate
    >
      <span id={validationId}>{message}</span>
    </FixaHelperText>
  );
};
